<template>
  <div class="wizard-view">
    <loading v-if="isWizardFetching || !isWizardAvailable" />
    <wizard v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { redirectToConsole } from '@/library/redirectToConsole';
import Loading from '@/app/components/Loading';
import Wizard from '@/app/components/wizard/Wizard';
import { Permissions } from '../services/UserPermissionsService';

export default {
  name: 'WizardView',
  components: {
    Loading,
    Wizard
  },
  computed: {
    ...mapGetters('app', [
      'isWizardFetching',
      'isWizardAvailable',
      'hasUserPermissions'
    ])
  },
  async created() {
    if (this.hasUserPermissions(Permissions.accessWizard)) {
      await this.fetchWizard();
    }
    if (!this.isWizardAvailable) {
      redirectToConsole();
    }
  },
  methods: {
    ...mapActions('app', [
      'fetchWizard'
    ])
  }
};
</script>

<style lang="scss" scoped>
@import '@uikit/ui-kit/themes/acronis/src/common/variables';

.wizard-view {
  height: 100%;
  background-color: $av-solid-brand-lightest;
}
</style>
